module.exports = __webpack_public_path__ + "static/media/medical_history_big.e6c47777.png";